export const tiposSolicitacoesProjetoEndpoint = {
    // Tipos de Solicitação de Projeto
    tiposSolicitacoesProjeto: {
        listar: `/api/v1/projetos/tipos-solicitacoes`,
        criar: `/api/v1/projetos/tipos-solicitacoes`,
        atualizar: (tipo_solicitacao_projeto_id) => `/api/v1/projetos/tipos-solicitacoes/${tipo_solicitacao_projeto_id}`,
        listarRubricasPorTipo: (tipo_solicitacao_projeto_id) => `/api/v1/projetos/tipos-solicitacoes/${tipo_solicitacao_projeto_id}/rubricas`,
        vincularRubrica: `/api/v1/projetos/tipos-solicitacoes/rubricas`,
        desvincularRubrica: (tiposolicitacaoprojetorubricalink_id) => `/api/v1/projetos/tipos-solicitacoes/rubricas/${tiposolicitacaoprojetorubricalink_id}`,
    },
}